export const CONSTANTES = {
  RUTA: {
    basename: "/cobranzas",
    path: "/",
    login: "/login",
    login2: "/login/?flujo=2",
    login3: "/login/?flujo=3",
    login4: "/login/?flujo=4",
    detalle: "/home",
    blankpage: "/blankpage",
    reportediario: "/reportediario",
    afiliacion: "/afiliacion",
    metodospago: "/metodospago",
  },

  SEPARADOR: "||",
  CODE_FLEXIVIDA: 8917
};

export const LISTA_TIPO_OPERACIONES = [
  {
    id: "PAGO_EN_LINEA",
    text: "Pago en línea",
  },
  {
    id: "PAGO_EN_LINEA_SUSCRIPCION",
    text: "Pago en línea Afiliación",
  },
  {
    id: "SUSCRIPCION",
    text: "Afiliación",
  },
];

export const LISTA_TIPO_OPERACIONES_FLEXIVIDA = [
  {
    id: "PAGO_EN_LINEA",
    text: "Pago en línea",
  },
  {
    id: "SUSCRIPCION",
    text: "Afiliación",
  },
];
 //Ini - 315301
 export const LISTA_OPERACION_COB = [
  {
    id: "CVC",
    text: "Cambio de medio de pago",
  },
  {
    id: "FIN",
    text: "Financiamiento",
  },
];

export const LISTA_OPERACION_COB_VIDA = [
  {
    id: "CVC",
    text: 'Cambio de medio de pago'
  }
];
//Fin - 315301